import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import { ProjectSwitcher } from "@amtana/project-client";

import { PROJECT_CATALOGS } from "./model/project-copy.ts";
import { PROJECT_ERROR_COPY } from "./model/project-error-copy.ts";

// Projects: the Settings page (create, rename, delete, switch) and the top
// bar's switcher, lent to the shell.
export const projectBrowserModule: BrowserModule = defineBrowserModule("project")
  .withErrorCopy(PROJECT_ERROR_COPY)
  .withScreens({
    projects: {
      path: "/settings/projects",
      title: phrase(PROJECT_CATALOGS, "screenTitle"),
      layout: "app",
      load: () => import("./ui/sections/projects-screen.tsx"),
    },
  })
  .withLends([{ token: ProjectSwitcher, load: () => import("./ui/blocks/project-switcher.tsx") }])
  .withNavigation([
    {
      id: "projects",
      group: "settings-workspace",
      label: phrase(PROJECT_CATALOGS, "navProjects"),
      href: "/settings/projects",
      icon: "folder",
      order: 852,
    },
  ]);
